import React from 'react';
import Notification from "@Features/notification/components/Notification";
import IconMTicketQrShifted from "@Icons/IconMTicketQrShifted";
import Column from "@Containers/components/Column";
import {useTranslation} from "@Translation/hooks/useTranslation";
import MTicketEcoFriendlyLabel from "@Route/components/MTicket/MTicketEcoFriendlyLabel";
import IconPaperTicket from "@Icons/IconPaperTicket";
import {RouteTransferTypeKeys} from "@Route/features/transportType/types/routeTransferType.type";
import Translation from "@Translation/components/Translation";
import {routeTransferTypes} from "@Route/features/transportType/constants/routeTransferTypes";

interface TicketTypeNotificationProps {
    hasMTicket: boolean,
    routeType: RouteTransferTypeKeys,
}

function TicketTypeNotification({hasMTicket, routeType}: TicketTypeNotificationProps) {
    const {
        ticket_has_to_be_printed: paperTicketDescription,
    } = useTranslation("search_results")

    if (hasMTicket) {
        return (
            <Notification
                notificationIcon={<IconMTicketQrShifted width="30" height="30"/>}
                notificationType="green"
                isBorder
                isRow
            >
                <Column>
                    <MTicketEcoFriendlyLabel/>
                    <Translation
                        translationKey={`search_results.has_mticket_desc.${routeTransferTypes[routeType]}`}
                    />
                </Column>
            </Notification>
        )
    }
    return (
        <Notification
            notificationIcon={<IconPaperTicket width="30" height="30"/>}
            notificationType="orange"
            isBorder
            isRow
        >
            <Column>
                <span className="gb--emphasize-warning">Paper ticket</span>
                {paperTicketDescription}
            </Column>
        </Notification>
    );
}

export default TicketTypeNotification;